/*
 *  -----------------------------------------------------------------------
 *    <copyright file="generation-history/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2024 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import GenerationHistory from '@pages/shared/generation-history/generatrion-history';

export default GenerationHistory;
